/**
 * Quill 2: use built-in size StyleAttributor with extended whitelist (8–72px).
 * Must be imported before ReactQuill mounts.
 */
import Quill from "quill";

const SizeStyle = Quill.import("attributors/style/size");
const whitelist = [];
for (let px = 8; px <= 72; px++) {
  whitelist.push(`${px}px`);
}
SizeStyle.whitelist = whitelist;

// Override both so the editor uses pixel size (style) instead of class (small/large/huge)
Quill.register(
  {
    "attributors/style/size": SizeStyle,
    "formats/size": SizeStyle,
  },
  true
);

export default SizeStyle;
